import React from 'react';
import AdSense from 'react-adsense';
import { googleAdsenseId } from '../../../constants';
import { Col, Row } from 'react-bootstrap';

export enum AdType {
    LANDSCAPE_LARGE = '2952584011',
}

type AdsContainerProps = {
    type: AdType;
};

export const AdsContainer = ({ type }: AdsContainerProps) => {
    return (
        <Row className={'my-2'}>
            <Col className={'d-flex justify-content-center'}>
                <AdSense.Google client={googleAdsenseId} slot={type} style={{ display: 'block', width: '80%' }} layout='in-article' format='fluid' />
            </Col>
        </Row>
    );
};
